import React from 'react';
import { useQuery } from 'react-query';
import { Box, Grid, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { fetchRegistry, getIzvorPrihoda } from '../api';
import { dateFormatReverse } from '../utils';
import ServerError from './ServerError';
import Spinner from './Spinner';

const ClientDetailsPartner = ({ client }) => {
  const registry = useQuery('registry', fetchRegistry);
  const incomeSources = useQuery('incomeSources', getIzvorPrihoda);

  const getIzvorName = (sifra) => {
    for (let i = 0; i < incomeSources.data.length; i++) {
      if (sifra == incomeSources.data[i].value) return incomeSources.data[i].text;
    }
    return null;
  };
  const getBracniStatusName = (sifra) => {
    for (let i = 0; i < registry.data.martialStatus.length; i++) {
      if (sifra == registry.data.martialStatus[i].value) return registry.data.martialStatus[i].text;
    }
    return null;
  };
  const nazivGrada = () => {
    for (let i = 0; i < registry.data.municipalities.length; i++) {
      if (registry.data.municipalities[i].value === client.opstina) {
        return registry.data.municipalities[i].text;
      }
    }
  };

  const mjestoStanovanjaname = (sifra) => {
    for (let i = 0; i < registry.data.localCommunities.length; i++) {
      if (sifra == registry.data.localCommunities[i].value) return registry.data.localCommunities[i].text;
    }
    return null;
  };
  return (
    <Box>
      <Box textAlign="center" m={4} pt={2} pb={2} mt={2}>
        <Typography variant="h6">
          {client.ime} {client.otac == null ? '' : `(${client.otac})`} {client.prezime}
        </Typography>
      </Box>
      {(registry.error || incomeSources.error) && <ServerError error={registry.error || incomeSources.error} />}
      {(registry.isLoading || incomeSources.isLoading) && <Spinner />}
      {registry.data && incomeSources.data && (
        <Grid container>
          <Grid item xs={6}>
            <Box width="100%" display="flex" flexDirection="column" p={1} m={1} pb={0} mb={0} ml={1}>
              <Typography variant="body2">Tip</Typography>
              <BotText variant="subtitle1">
                {client.vrstaKomitenta == 'F' && 'Fizičko lice'}
                {client.vrstaKomitenta == 'P' && 'Pravno lice'}
              </BotText>
              <Typography variant="body2">Broj mobitela</Typography>
              <BotText variant="subtitle1">{client.telefon || '-'}</BotText>
              <Typography variant="body2">Adresa</Typography>
              <BotText variant="subtitle1">{client.adresa || '-'}</BotText>
              <Typography variant="body2">Grad</Typography>
              <BotText noWrap variant="subtitle1">
                {nazivGrada()}
              </BotText>
              <Typography variant="body2">Mjesto stanovanja</Typography>
              <BotText noWrap variant="subtitle1">
                {mjestoStanovanjaname(client.mjestoStanovanja) || '-'}
              </BotText>
              <Typography variant="body2">Broj LK</Typography>
              <BotText variant="subtitle1">{client.lk || '-'}</BotText>
              <Typography variant="body2">Izvor prihoda</Typography>
              <BotText noWrap variant="subtitle1">
                {getIzvorName(client.izvorPrihoda) || '-'}
              </BotText>
              <Typography variant="body2">Status zaposlenja</Typography>
              <BotText variant="subtitle1">{client.statusZaposlenja || '-'}</BotText>
            </Box>
          </Grid>
          <Grid item xs={6}>
            <Box width="100%" display="flex" flexDirection="column" p={1} m={1} pb={0} mb={0}>
              <Typography variant="body2">JMBG</Typography>
              <BotText variant="subtitle1">{client.komitent || '-'}</BotText>
              <Typography variant="body2">Broj fiksnog</Typography>
              <BotText variant="subtitle1">{client.telefonFix || '-'}</BotText>
              <Typography variant="body2">Adresa cips</Typography>
              <BotText variant="subtitle1">{client.adresaCips || '-'}</BotText>
              <Typography variant="body2">Grad cips</Typography>
              <BotText noWrap variant="subtitle1">
                {client.opcinaCips || '-'}
              </BotText>
              <Typography variant="body2">Spol</Typography>
              <BotText variant="subtitle1">
                {client.spol == registry.data.genders[0].value && registry.data.genders[0].text}
                {client.spol == registry.data.genders[1].value && registry.data.genders[1].text}
                {client.spol != registry.data.genders[0].value && client.spol != registry.data.genders[1].value && '-'}
              </BotText>
              <Typography variant="body2">Datum isteka LK</Typography>
              <BotText variant="subtitle1">
                {client.datumIstekaLK ? dateFormatReverse(client.datumIstekaLK) : '-'}
              </BotText>
              <Typography variant="body2">Bračni status</Typography>
              <BotText noWrap variant="subtitle1">
                {getBracniStatusName(client.statusKomitenta) || '-'}
              </BotText>
            </Box>
          </Grid>
          <Grid item xs={12}>
            <Box display="flex" flexDirection="column" p={1} pt={0} m={1} mt={0}>
              <Typography variant="body2">Napomena</Typography>
              <BotText variant="subtitle1">{client.napomena || '-'}</BotText>
            </Box>
          </Grid>
        </Grid>
      )}
    </Box>
  );
};
const BotText = styled(Typography)`
  margin-bottom: 24px;
`;
export default ClientDetailsPartner;
